<template>
  <div>
    <validation-observer
      ref="registerVisitForm"
      novalidate
      tag="form"
      @submit.prevent="submitForm"
    >
      <div class="first-custom-row">
        <div class="day">
          <label class="data-title mb-0">Día:</label>
          <validation-provider v-slot="{ errors }" name="Día" rules="required">
            <custom-input
              id="day"
              ref="visitDayRegisterInput"
              v-model="visitDay"
              class="hour-size"
              custom-error-msg=""
              :error="errors[0]"
              mask-type="Day"
              type="text"
            />
          </validation-provider>
        </div>

        <div
          class="pl-2 custom-standard-width"
          :class="{ 'hours-column': isAssistantServiceType || isTherapyABA }"
        >
          <label class="data-title mb-0">Hora Desde:</label>
          <div class="d-flex">
            <validation-provider
              v-slot="{ errors }"
              name="HourStartHour"
              rules="required"
            >
              <custom-input
                id="hourStartHour"
                v-model="model.hourStartHour"
                class="hour-size"
                custom-error-msg=""
                :error="errors[0]"
                mask-type="Day"
                type="text"
                @input="evalEnterHour"
              />
            </validation-provider>

            <span class="mr-2 mt-1">:</span>

            <validation-provider
              v-slot="{ errors }"
              name="HourStartMinute"
              rules="required"
            >
              <custom-input
                id="hourStartMinute"
                v-model="model.hourStartMinute"
                class="hour-size-bigger"
                custom-error-msg=""
                :error="errors[0]"
                mask-type="Day"
                type="text"
              />
            </validation-provider>

            <div v-if="model.ampmDisabled" class="is-disabled-input-style">
              <span class="disabled-box-content">
                {{ hourStartTimeSelected.text }}
              </span>
              <div class="disabled-icon-style">
                <i class="fas fa-angle-down angle-down-style" />
              </div>
            </div>
            <template v-else>
              <validation-provider
                v-slot="{ errors }"
                name="hourStartTime"
                rules="required"
              >
                <custom-drop-down
                  id="hourStartTime"
                  v-model="hourStartTimeSelected"
                  class="ampm-size"
                  :clearable="false"
                  custom-error-msg=""
                  :error="errors[0]"
                  fieldkey="value"
                  fieldname="text"
                  :options="timeOptions"
                  @input="onChangeHourStartTime"
                />
              </validation-provider>
            </template>
          </div>
          <div
            v-if="isAssistantServiceType || isTherapyABA"
            class="d-flex mt-2"
          >
            <validation-provider
              v-slot="{ errors }"
              name="hourContinuedStartHour"
              :rules="isSecondHourRequired ? 'required' : null"
            >
              <custom-input
                id="hourContinuedStartHour"
                v-model="model.hourContinuedStartHour"
                class="hour-size"
                custom-error-msg=""
                :error="errors[0]"
                mask-type="Day"
                type="text"
              />
            </validation-provider>

            <span class="mr-2 mt-1">:</span>

            <validation-provider
              v-slot="{ errors }"
              name="hourContinuedStartMinute"
              :rules="isSecondHourRequired ? 'required' : null"
            >
              <custom-input
                id="hourContinuedStartMinute"
                v-model="model.hourContinuedStartMinute"
                class="hour-size-bigger"
                custom-error-msg=""
                :error="errors[0]"
                mask-type="Day"
                type="text"
              />
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              name="hourContinuedStartTime"
              :rules="isSecondHourRequired ? 'required' : null"
            >
              <custom-drop-down
                id="hourContinuedStartTime"
                v-model="hourContinuedStartTimeSelected"
                class="ampm-size"
                :class="
                  hourContinuedStartTimeSelected ? 'hide-dropdown-arrow' : ''
                "
                :error="errors[0]"
                fieldkey="value"
                fieldname="text"
                :options="timeOptions"
                @input="onChangeHourContinuedStartTime"
              />
            </validation-provider>
          </div>
        </div>

        <div
          class="custom-standard-width"
          :class="{ 'hours-column': isAssistantServiceType || isTherapyABA }"
        >
          <label
            class="data-title mb-0"
            :class="isAssistantServiceType || isTherapyABA ? '' : 'pl-3'"
          >
            Hora Hasta:
          </label>
          <div v-if="isAssistantServiceType || isTherapyABA" class="d-flex">
            <validation-provider
              v-slot="{ errors }"
              name="hourEndHour"
              rules="required"
            >
              <custom-input
                id="hourEndHour"
                v-model="model.hourEndHour"
                class="hour-size"
                custom-error-msg=""
                :error="errors[0]"
                mask-type="Day"
                type="text"
              />
            </validation-provider>

            <span class="mr-2 mt-1">:</span>

            <validation-provider
              v-slot="{ errors }"
              name="hourEndMinute"
              rules="required"
            >
              <custom-input
                id="hourEndMinute"
                v-model="model.hourEndMinute"
                class="hour-size-bigger"
                custom-error-msg=""
                :error="errors[0]"
                mask-type="Day"
                type="text"
              />
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              name="hourEndTime"
              rules="required"
            >
              <custom-drop-down
                id="hourEndTime"
                v-model="hourEndTimeSelected"
                class="ampm-size"
                :clearable="false"
                custom-error-msg=""
                :error="errors[0]"
                fieldkey="value"
                fieldname="text"
                :options="timeOptions"
                @input="onChangeHourEndTime"
              />
            </validation-provider>
          </div>
          <div v-else>
            <div class="pl-3 mt-1">
              <span>{{ endTime }}</span>
            </div>
          </div>
          <div
            v-if="isAssistantServiceType || isTherapyABA"
            class="d-flex mt-2"
          >
            <validation-provider
              v-slot="{ errors }"
              name="hourContinuedEndHour"
              :rules="isSecondHourRequired ? 'required' : null"
            >
              <custom-input
                id="hourContinuedEndHour"
                v-model="model.hourContinuedEndHour"
                class="hour-size"
                custom-error-msg=""
                :error="errors[0]"
                mask-type="Day"
                type="text"
              />
            </validation-provider>

            <span class="mr-2 mt-1">:</span>

            <validation-provider
              v-slot="{ errors }"
              name="hourContinuedEndMinute"
              :rules="isSecondHourRequired ? 'required' : null"
            >
              <custom-input
                id="hourContinuedEndMinute"
                v-model="model.hourContinuedEndMinute"
                class="hour-size-bigger"
                custom-error-msg=""
                :error="errors[0]"
                mask-type="Day"
                type="text"
              />
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              name="hourContinuedEndTime"
              :rules="isSecondHourRequired ? 'required' : null"
            >
              <custom-drop-down
                id="hourContinuedEndTime"
                v-model="hourContinuedEndTimeSelected"
                class="ampm-size"
                :class="
                  hourContinuedEndTimeSelected ? 'hide-dropdown-arrow' : ''
                "
                :error="errors[0]"
                fieldkey="value"
                fieldname="text"
                :options="timeOptions"
                @input="onChangeHourContinuedEndTime"
              />
            </validation-provider>
          </div>
        </div>

        <div class="custom-standard-width">
          <validation-provider v-slot="{ errors }" :rules="'required'">
            <label class="data-title mb-0">Tipo de Visita:</label>
            <custom-drop-down
              id="visitType"
              v-model="visitType"
              class="mr-3"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="visitTypes"
              placeholder="Seleccione"
              @input="onChangeVisitType()"
            />
          </validation-provider>
          <div v-if="visitType && visitType.value.showPreviousYears">
            <span class="color-secondary-6 font-weight-normal font-14">
              Año Anterior:
            </span>
            <ValidationProvider v-slot="{ errors }" rules="required">
              <CustomDropDown
                v-model="previousAcademicYear"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="previousAcademicYears"
                @input="onPreviousAcademicYearChanged()"
              />
            </ValidationProvider>
          </div>
          <div
            v-if="
              visitType &&
                visitType.value.showPreviousYears &&
                filteredPreviousCompensatories.length > 0 &&
                previousAcademicYear &&
                previousAcademicYear.id > 0
            "
          >
            <span class="color-secondary-6 font-weight-normal font-14">
              Solicitud:
            </span>
            <ValidationProvider v-slot="{ errors }" rules="required">
              <CustomDropDown
                v-model="compensatoryRequestSelected"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="filteredPreviousCompensatories"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="custom-standard-width">
          <validation-provider v-slot="{ errors }" :rules="'required'">
            <label class="data-title mb-0">Especialista:</label>

            <custom-drop-down
              id="specialist"
              ref="specialistDropdownRef"
              v-model="specialist"
              class="mr-3"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="getSpecialists"
              placeholder="Seleccione"
              @input="onSpecialistChange"
            />
          </validation-provider>
        </div>
        <div v-if="canEditCpt" class="cpt-width col-spacing">
          <label class="data-title mb-0">CPT:</label>

          <ValidationProvider v-slot="{ errors }" name="cpt" rules="required">
            <CustomDropDown
              v-model="cpt"
              class="w-100"
              :disabled="feeScheduleCptOptions.length <= 1"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="feeScheduleCptOptions"
              placeholder="Seleccione"
            />
          </ValidationProvider>
        </div>
        <div v-if="canEditSupervisor" class="supervisor-width col-spacing">
          <label class="data-title mb-0">Supervisor:</label>
          <ValidationProvider
            v-slot="{ errors }"
            name="supervisor"
            rules="required"
          >
            <custom-drop-down
              v-model="supervisor"
              class="w-100 supervisor-dropdown"
              :disabled="supervisors.length === 1"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="supervisors"
              placeholder="Seleccione"
            />
          </ValidationProvider>
        </div>

        <div v-if="showTransportation" class="required-transportation">
          <div class="d-flex align-items-center">
            <div
              class="custom-control custom-checkbox checkbox-top-spacing transportation-mt"
            >
              <check-box
                id="chTransportation"
                v-model="model.transportation"
                name="chTransportation"
                text="Requiere Transportación"
              />
            </div>
          </div>
        </div>

        <div
          :class="
            (includesTransportation && !isCybertherapyVisitType
              ? 'submit-btn-width'
              : 'custom-standard-width',
            {
              'col-md-1': canEditCpt,
            })
          "
        >
          <div class="submit-btn-position">
            <action-button
              id="submit-btn"
              i="fas fa-save pl-1 mt-1"
              variant="success"
              @click="submitForm()"
            />
          </div>
        </div>
      </div>

      <div class="custom-row">
        <template v-if="isCyberTherapyOrPresentialCurrentYearVisitType">
          <div
            class="custom-standard-width"
            :class="isTherapyABA ? 'mt-2' : 'offset-lg mt-3'"
          >
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <label class="data-title mb-0">Fecha a Reponer:</label>
              <custom-drop-down
                id="repositionDate"
                v-model="repositionDate"
                class="mr-3"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="visitsValidForReposition"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
        </template>

        <template v-if="isAbsenceVisitType">
          <div
            class="large-width"
            :class="isTherapyABA ? 'mt-1' : 'offset-lg mt-2'"
          >
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <label class="data-title mb-0">Justificación:</label>

              <custom-drop-down
                id="visitAbsenceReason"
                v-model="visitAbsenceReason"
                class="mr-3"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="getAbsenceReasons"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div
            v-if="isStudentExcusedAbsence"
            class="custom-standard-width"
            :class="isTherapyABA ? 'mt-1' : 'mt-2'"
          >
            <label class="data-title mb-0">Certificado Médico:</label>
            <validation-provider
              v-slot="{ errors }"
              name="fileUpload"
              rules="required"
            >
              <custom-file-input
                id="customInptFileUploadDocumentsPdf"
                accept=".pdf"
                accept-terms-modal-title="Certificación"
                accept-terms-text="Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)"
                accept-terms-title="Acepto los términos y responsabilidades"
                accept-terms-validation-msg="Favor certifique el documento  que ha subido al sistema REMpro."
                add-text=" "
                allow-accept-terms
                class="file-input__extended"
                :class="!fileSelected ? 'file-input-width' : ''"
                :custom-error-msg="''"
                display-style="normal"
                :error="errors[0]"
                :on-download="() => {}"
                required
                :value="fileSelected"
                @input="onFileSelected"
              />
            </validation-provider>
          </div>
        </template>

        <template v-if="isCyberTherapyOrPresentialCurrentYearVisitType">
          <div class="large-width" :class="isTherapyABA ? 'mt-2' : 'mt-3'">
            <label class="data-title mb-0">Comentario:</label>
            <custom-input
              id="comment"
              v-model="model.comment"
              :count-classes="['float-right']"
            />
          </div>
        </template>
      </div>

      <div
        v-if="isAbsenceVisitType"
        class="custom-row"
        :class="isStudentExcusedAbsence ? 'mt-2' : 'mt-3'"
      >
        <div class="offset-lg extra-large-width">
          <label class="data-title mb-0">Comentario:</label>
          <custom-input
            id="comment"
            v-model="model.comment"
            :count-classes="['float-right']"
          />
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import moment from 'moment';
import get from 'lodash/get';
import { ValidationProvider } from 'vee-validate';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import alert from '@quisit/mipe-utils/mixins/alert.mixin.js';
import CustomDropDown from 'custom-drop-down';
import CustomFileInput from 'CustomFileInput';
import CheckBox from 'CheckBox';
import { capitalize } from '@/filters';
import rpServiceTypes from '@/utils/constants/serviceTypes.js';
import visitTypes from '@/utils/constants/rpVisitTypes.js';
import disciplineTypes from '@/utils/constants/disciplineTypes';
import rpVisitAbsenceReasons from '@/utils/constants/rpVisitAbsenceReasons.js';
import objectToFormData from 'object-to-formdata';
import {
  validateDayEntry,
  validateEmptyTimeEntry,
  validateContractRules,
  validateVisitShiftDuration,
} from '@/services/uspqrp/visitService.js';
import {
  getVisitTypes as _getVisitTypes,
  CancellationToken as _getCancellationToken,
} from '@/services/common/code.api.js';
import {
  getPreviousYearAndCompensatoryIdsForRegisterVisit as _getPreviousYearAndCompensatoryIdsForRegisterVisit,
  getSupervisors as _getSupervisors,
} from '@/services/uspqrp/visit.api.js';
import specialtyTypes from '@/utils/constants/specialtyTypes';
export default {
  name: 'VisitRegistryForm',
  components: {
    ValidationProvider,
    CustomInput,
    ActionButton,
    CustomDropDown,
    CheckBox,
    CustomFileInput,
  },
  mixins: [alert],
  props: {
    therapyCompensatoryInfo: {
      type: Object,
      default: () => {},
    },
    contractSpecialists: {
      type: Array,
      default: () => {},
    },
    defaultSpecialistId: {
      type: Number,
      default: 0,
    },
    serviceDuration: {
      type: Number,
      default: 0,
    },
    visitsValidForReposition: {
      type: Array,
      default: () => [],
    },
    includesTransportation: {
      type: Boolean,
      default: false,
    },
    contractSchedule: {
      type: Object,
      default: () => {},
    },
    contractStartDate: {
      type: String,
      default: '',
    },
    requestServiceTypeId: {
      type: Number,
      default: 0,
    },
    disciplineTypeId: {
      type: Number,
      default: 0,
    },
    visitAbsenceReasons: {
      type: Array,
      default: () => [],
    },
    selectedPeriod: {
      type: Object,
      default: () => {},
    },
    isTherapyABA: {
      type: Boolean,
      default: () => false,
    },
    isExtendedAcademicYear: {
      type: Boolean,
      default: false,
    },
    isCompensatoryRequest: {
      type: Boolean,
      default: false,
    },
    compensatoryRequestId: {
      type: Number,
      default: null,
    },
    feeScheduleCptOptions: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.getSupervisors();
  },
  data() {
    return {
      dayChangeCancellationToken: null,
      model: {
        comment: null,
        day: null,
        hourStartHour: null,
        hourStartMinute: null,
        hourStartTime: null,
        hourEndHour: null,
        hourEndMinute: null,
        hourEndTime: null,
        transportation: false,
        hourContinuedStartHour: null,
        hourContinuedStartMinute: null,
        hourContinuedStartTime: null,
        hourContinuedEndHour: null,
        hourContinuedEndMinute: null,
        hourContinuedEndTime: null,
        ampmDisabled: null,
      },
      visitDay: null,
      visitType: null,
      cpt: null,
      supervisor: null,
      repositionDate: null,
      specialist: null,
      visitAbsenceReason: null,
      fileSelected: null,
      hourStartTimeSelected: null,
      hourEndTimeSelected: null,
      hourContinuedStartTimeSelected: null,
      hourContinuedEndTimeSelected: null,
      isSecondHourRequired: null,
      visitTypes: [],
      previousAcademicYears: [],
      previousCompensatories: [],
      previousAcademicYear: null,
      filteredPreviousCompensatories: [],
      compensatoryRequestSelected: null,
      excludeVisitType: [22],
      supervisors: [],
    };
  },
  computed: {
    studentSieId() {
      return this.therapyCompensatoryInfo.studentSieId;
    },
    canEditCpt() {
      return this.therapyCompensatoryInfo.canEditCpt;
    },
    canEditSupervisor() {
      return (
        this.therapyCompensatoryInfo.canEditCpt &&
        this.specialist?.licenses.some(
          (s) =>
            s.id == specialtyTypes.OccupationalTherapyAssistant ||
            s.id == specialtyTypes.PhysicalTherapyAssistant
        )
      );
    },
    isInterpreterDiscipline() {
      return disciplineTypes.Interprete === this.disciplineTypeId;
    },
    showTransportation() {
      const specialistNeedTransportation = get(
        this.specialist,
        'specialistNeedTransportation',
        false
      );
      let showTransportation = false;
      if (
        this.visitType != null &&
        this.visitType.value != null &&
        this.visitType.value.showTransportation != null
      ) {
        showTransportation = this.visitType.value.showTransportation;
      }
      if (showTransportation) {
        return this.isInterpreterDiscipline
          ? this.includesTransportation && specialistNeedTransportation
          : this.includesTransportation;
      }
      return this.isInterpreterDiscipline
        ? showTransportation && specialistNeedTransportation
        : showTransportation;
    },
    hasContractStartDate() {
      return !!this.contractStartDate;
    },
    isCybertherapyVisitType() {
      if (!this.visitType) return false;
      return (
        this.visitType.id === visitTypes.RegularCybertherapy ||
        this.visitType.id === visitTypes.CybertherapyRepositionCurrentYear ||
        this.visitType.id === visitTypes.Absence
      );
    },
    getAbsenceReasons() {
      const reasons = this.visitAbsenceReasons.filter(
        (x) =>
          x.id === rpVisitAbsenceReasons.SituacionesAtribuiblesAgencia ||
          x.id ===
            rpVisitAbsenceReasons.AusenciaAtribuiblesProveedorServicios ||
          x.id === rpVisitAbsenceReasons.AusenciaEstudianteJustificada ||
          x.id === rpVisitAbsenceReasons.AusenciaEstudianteNoJustificada ||
          x.id === rpVisitAbsenceReasons.AusenciaEspecialista ||
          x.id === rpVisitAbsenceReasons.DiaNoLectivoConcedidoPorElEstado
      );

      return reasons;
    },
    isRegularVisitType() {
      if (!this.visitType) return true;
      return (
        this.visitType.id === visitTypes.RegularPresential ||
        this.visitType.id === visitTypes.RegularCybertherapy
      );
    },
    isRepositionVisitType() {
      if (!this.visitType) return true;
      return (
        this.visitType.id === visitTypes.CybertherapyRepositionCurrentYear ||
        this.visitType.id === visitTypes.CybertherapyRepositionDeLastYear ||
        this.visitType.id === visitTypes.PresentialRepositionCurrentYear ||
        this.visitType.id === visitTypes.PresentialRepositionDeLastYear
      );
    },
    getVisitTypesByServiceType() {
      const filteredVisits = this.visitTypes.filter(
        (x) =>
          x.id !== visitTypes.PresentialRepositionDeLastYear &&
          x.id !== visitTypes.CybertherapyRepositionDeLastYear
      );
      if (this.isAssistantServiceType) {
        return filteredVisits.filter(
          (x) =>
            x.id !== visitTypes.PresentialRepositionCurrentYear &&
            x.id !== visitTypes.CybertherapyRepositionCurrentYear &&
            x.id !== visitTypes.PresentialRepositionDeLastYear &&
            x.id !== visitTypes.CybertherapyRepositionDeLastYear &&
            x.id !== visitTypes.Absence &&
            x.id !== visitTypes.RegularCybertherapy
        );
      }
      return filteredVisits;
    },
    getCurrentVisitType() {
      return this.visitType?.id;
    },
    isCyberTherapyOrPresentialCurrentYearVisitType() {
      return (
        this.getCurrentVisitType ===
          visitTypes.PresentialRepositionCurrentYear ||
        this.getCurrentVisitType ===
          visitTypes.CybertherapyRepositionCurrentYear
      );
    },
    isAbsenceVisitType() {
      return this.getCurrentVisitType === visitTypes.Absence;
    },
    contractId() {
      return Number(this.$route.params?.contractId);
    },
    companyId() {
      return Number(this.$route.params?.companyId);
    },
    academicYearId() {
      return Number(this.$route.params?.academicYearId);
    },
    padStartHour() {
      const h = this.model.hourStartHour;
      return h != null ? h.toString().padStart(2, '0') : '00';
    },
    padStartMinute() {
      const m = this.model.hourStartMinute;
      return m != null ? m.toString().padStart(2, '0') : '00';
    },
    startTime() {
      const hour = this.padStartHour;
      const minute = this.padStartMinute;
      const ampm = (this.model.hourStartTime || '').toUpperCase();

      const timeString = `${hour}:${minute} ${ampm}`;
      const momentTime = moment(timeString, 'hh:mm A');

      return momentTime.isValid() ? momentTime : '';
    },
    endTime() {
      if (
        this.isValidStartHour(this.model) &&
        this.serviceDuration &&
        !this.isAssistantServiceType &&
        !this.isTherapyABA
      ) {
        if (
          !this.startTime ||
          !moment.isMoment(this.startTime) ||
          !this.startTime.isValid()
        ) {
          return '';
        }

        return this.startTime
          .clone()
          .add(this.serviceDuration, 'minutes')
          .format('hh:mm A');
      }
      return '';
    },
    timeOptions() {
      return [
        { value: 'am', text: 'AM' },
        { value: 'pm', text: 'PM' },
      ];
    },
    getSpecialists() {
      if (!this.contractSpecialists) return [];
      return this.contractSpecialists.map(
        ({
          specialistId,
          specialistName,
          specialistNeedTransportation,
          licenses,
        }) => {
          return {
            id: specialistId,
            name: capitalize(specialistName),
            specialistNeedTransportation,
            licenses,
          };
        }
      );
    },
    isAssistantServiceType() {
      return this.requestServiceTypeId === rpServiceTypes.Assistant;
    },
    isStudentExcusedAbsence() {
      if (!this.visitAbsenceReason) return false;
      return this.visitAbsenceReason.requiresDocumentationFlag;
    },
  },
  methods: {
    onSpecialistChange(event) {
      if (event == null) {
        this.supervisors = [];
        this.specialist = null;
        this.supervisor = null;
      } else {
        this.getSupervisors();
      }
    },
    async getSupervisors() {
      const { data } = await _getSupervisors(this.specialist?.id);
      this.supervisors = data;
      if (this.supervisors.length === 1 && !this.model?.supervisor) {
        this.supervisor = this.supervisors[0];
      }
    },
    setFeeScheduleCpt() {
      if (this.feeScheduleCptOptions.length == 1 && this.canEditCpt) {
        this.cpt = this.feeScheduleCptOptions[0];
      }
    },
    getAmPm(valueHour) {
      let result = { time: 'am', disabled: true };
      if (valueHour == 12 || (valueHour >= 1 && valueHour <= 6)) {
        result.time = 'pm';
      } else if (valueHour >= 8 && valueHour <= 11) {
        result.time = 'am';
      } else {
        result.disabled = false;
      }
      return result;
    },
    evalEnterHour() {
      if (
        this.model.hourStartHour &&
        !this.isAssistantServiceType &&
        !this.isTherapyABA
      ) {
        const parsedHour = parseInt(this.model.hourStartHour);
        const ampmResult = this.getAmPm(parsedHour);
        this.model.ampmDisabled = ampmResult.disabled;
        this.hourStartTimeSelected = this.timeOptions.find(
          (x) => x.value === ampmResult.time
        );
        this.onChangeHourStartTime(this.hourStartTimeSelected);
      }
    },
    async onDayChange() {
      if (this.model.day) {
        //Validate if the cancellation token is already created
        if (this.dayChangeCancellationToken) {
          this.dayChangeCancellationToken.cancel(
            'Request cancelled due to new day selection.'
          );
        }

        this.dayChangeCancellationToken = _getCancellationToken();

        const { data } = await _getVisitTypes(
          this.model.day,
          this.selectedPeriod.monthNumber,
          this.selectedPeriod.year,
          this.contractId,
          this.academicYearId,
          this.disciplineTypeId,
          this.dayChangeCancellationToken
        );

        if (!this.userHasPermissions('register.visits.without.restriction')) {
          this.excludeVisitType.push(9);
        }

        if (data != undefined) {
          this.visitTypes = data.filter(
            (x) => !this.excludeVisitType.includes(x.id)
          );
        } else {
          this.visitTypes = [];
        }
      } else {
        this.visitTypes = [];
      }

      this.visitType = null;
    },
    onFileSelected(file) {
      this.fileSelected = file;
    },
    isValidStartHour(item) {
      let isValid = false;
      const _values = {
        hour: item.hourStartHour?.toString().padStart(2, '0') ?? '00',
        min: item.hourStartMinute?.toString().padStart(2, '0') ?? '00',
        ampm: item.hourStartTime?.toUpperCase(),
      };

      // Return false if minutes are not set
      if (!item.hourStartMinute) {
        return false;
      }

      const visitHour = moment(
        `${_values.hour}:${_values.min} ${_values.ampm}`,
        'hh:mm A',
        true
      );
      //Validate if the hour is valid and validate against the schedule hour of contract
      if (visitHour.isValid()) {
        const scheduleHour = moment(this.contractSchedule.start, 'HH:mm:ss');
        isValid = visitHour.isSameOrAfter(scheduleHour);
      }

      return isValid;
    },
    onChangeHourStartTime(input) {
      this.model.hourStartTime = input?.value;
    },
    onChangeHourEndTime(input) {
      this.model.hourEndTime = input?.value;
    },
    onChangeHourContinuedStartTime(input) {
      this.model.hourContinuedStartTime = input?.value;
    },
    onChangeHourContinuedEndTime(input) {
      this.model.hourContinuedEndTime = input?.value;
    },
    //Validate all Visit Rules,
    validateVisitEntry(item) {
      item.isAbsenceVisitType = this.isAbsenceVisitType;
      let validations = [];
      validations.push(validateEmptyTimeEntry(item, this.contractSchedule));
      validations.push(
        validateDayEntry(
          item,
          this.selectedPeriod.monthNumber,
          this.selectedPeriod.year
        )
      );
      validations.push(
        validateContractRules(
          this.therapyCompensatoryInfo,
          this.hasContractStartDate
        )
      );
      validations = validations.flat();

      if (!this.visitType) validations.push('El tipo de visita es requerido.');

      if (!this.specialist) validations.push('El especialista es requerido.');
      if (this.canEditSupervisor && !this.supervisor)
        validations.push('El supervisor es requerido.');

      if (
        this.isCyberTherapyOrPresentialCurrentYearVisitType &&
        !this.repositionDate
      )
        validations.push('La fecha de reposición es requerida.');

      //Validate Visit Shift Duration
      if (this.isAssistantServiceType) {
        validations.push(...validateVisitShiftDuration(item));
      }

      return validations;
    },
    async getPreviousAcademicYearsAndCompensatories() {
      await _getPreviousYearAndCompensatoryIdsForRegisterVisit(
        this.studentSieId,
        this.disciplineTypeId
      )
        .then(({ data: res }) => {
          res.years.map((a) => {
            a.name = a.description;
          });
          this.previousAcademicYears = res.years;
          this.previousCompensatories = res.compensatories;
          this.filteredPreviousCompensatories = res.compensatories;
        })
        .catch(() => {});
    },
    async onPreviousAcademicYearChanged() {
      const previousAcademicYearIdSelected = this.previousAcademicYear?.id;
      if (previousAcademicYearIdSelected > 0) {
        this.filteredPreviousCompensatories = this.previousCompensatories.filter(
          (x) => x.academicYearId == previousAcademicYearIdSelected
        );
        if (
          this.filteredPreviousCompensatories.findIndex(
            (x) => x.id === this.compensatoryRequestSelected?.id
          ) === -1
        ) {
          this.compensatoryRequestSelected = null;
        }
      } else {
        this.filteredPreviousCompensatories = [];
        this.compensatoryRequestSelected = null;
      }
    },
    async onChangeVisitType() {
      const selectedTypeId = this.visitType?.id;
      this.canEditReposition = true;
      if (this.visitType && this.visitType.value.showPreviousYears) {
        await this.getPreviousAcademicYearsAndCompensatories();
      }
      if (selectedTypeId) {
        if (
          [
            visitTypes.Ausencia,
            visitTypes.VisitaReposicion,
            visitTypes.Ausencia_Ofrecimiento,
            visitTypes.Ciberterapia_Reposicion_Ano_Actual,
            visitTypes.Visita_Presencial_Reposicion_Ano_Actual_Covid19,
          ].includes(selectedTypeId)
        ) {
          if (
            selectedTypeId === visitTypes.VisitaReposicion ||
            selectedTypeId === visitTypes.Ausencia_Ofrecimiento ||
            selectedTypeId === visitTypes.Ciberterapia_Reposicion_Ano_Actual ||
            selectedTypeId ==
              visitTypes.Visita_Presencial_Reposicion_Ano_Actual_Covid19
          ) {
            this.getRepositionDates();
          }
          return;
        }
      }
    },
    cleanModel() {
      this.model = {
        comment: null,
        day: null,
        hourStartHour: null,
        hourStartMinute: null,
        hourStartTime: null,
        hourEndHour: null,
        hourEndMinute: null,
        hourEndTime: null,
        transportation: false,
        hourContinuedStartHour: null,
        hourContinuedStartMinute: null,
        hourContinuedStartTime: null,
        hourContinuedEndHour: null,
        hourContinuedEndMinute: null,
        hourContinuedEndTime: null,
        ampmDisabled: null,
      };
      this.visitType = null;
      this.repositionDate = null;
      this.fileSelected = null;
      this.visitAbsenceReason = null;
      this.hourContinuedStartHour = null;
      this.hourContinuedStartMinute = null;
      this.hourContinuedEndHour = null;
      this.hourContinuedEndMinute = null;
      this.hourStartTimeSelected = null;
      this.hourEndTimeSelected = null;
      this.hourContinuedStartTimeSelected = null;
      this.hourContinuedEndTimeSelected = null;
      this.visitDay = null;
      this.cpt = null;
      this.supervisor = null;
      this.specialist = null;
      this.$refs.registerVisitForm.reset();
      this.setFeeScheduleCpt();
    },
    getDays(year, month) {
      return new Date(year, month, 0).getDate();
    },
    async submitForm() {
      const isFormValid = await this.$refs.registerVisitForm.validate();
      //Set End Time when .end time computed has value
      if (this.endTime) {
        this.model.hourEndHour = this.endTime.split(':')[0];
        this.model.hourEndMinute = this.endTime.split(':')[1];
        this.model.hourEndTime = this.endTime.split(':')[2];
      }
      const validations = this.validateVisitEntry(this.model);
      let replacementVisitId = null;

      if (!isFormValid || validations.length) {
        this.$emit('is-invalid-model', validations);
        return;
      }
      let visitTimeEnd = this.endTime;
      let visitTimeContinuedStart = null;
      let visitTimeContinuedEnd = null;

      let visitDate = moment([
        this.selectedPeriod.year,
        this.selectedPeriod.monthNumber - 1,
        this.model.day,
      ])
        .format()
        .slice(0, -6);

      const visitTimeStart = moment(
        `${this.model.hourStartHour}:${this.model.hourStartMinute} ${this.model.hourStartTime}`,
        'hh:mm A'
      ).format('hh:mm A');

      if (this.isAssistantServiceType || this.isTherapyABA) {
        visitTimeEnd = moment(
          `${this.model.hourEndHour}:${this.model.hourEndMinute} ${this.model.hourEndTime}`,
          'hh:mm A'
        ).format('hh:mm A');
      }

      if (this.isAssistantServiceType || this.isTherapyABA) {
        if (
          this.model.hourContinuedStartHour &&
          this.model.hourContinuedStartMinute &&
          this.model.hourContinuedStartTime
        ) {
          visitTimeContinuedStart = moment(
            `${this.model.hourContinuedStartHour}:${this.model.hourContinuedStartMinute} ${this.model.hourContinuedStartTime}`,
            'hh:mm A'
          ).format('hh:mm A');
        }

        if (
          this.model.hourContinuedEndHour &&
          this.model.hourContinuedEndMinute &&
          this.model.hourContinuedEndTime
        ) {
          visitTimeContinuedEnd = moment(
            `${this.model.hourContinuedEndHour}:${this.model.hourContinuedEndMinute} ${this.model.hourContinuedEndTime}`,
            'hh:mm A'
          ).format('hh:mm A');
        }
      }

      if (this.isCyberTherapyOrPresentialCurrentYearVisitType) {
        replacementVisitId = this.isCyberTherapyOrPresentialCurrentYearVisitType
          ? this.repositionDate.id
          : null;
      }

      const payload = objectToFormData(
        {
          specialistId: this.specialist.id,
          contractId: this.contractId,
          visitDate, // to verify
          visitTimeStart,
          visitTimeEnd,
          visitTimeContinuedStart,
          visitTimeContinuedEnd,
          academicYearId: this.academicYearId,
          cptId: this.cpt?.id ?? null,
          supervisorId: this.supervisor?.id ?? null,
          monthNumber: this.selectedPeriod.monthNumber,
          companyId: this.companyId,
          visitSummaryId: null,
          visitIsCompensatory:
            this.compensatoryRequestSelected != null ?? false,
          isCyberTherapy: null,
          requestServiceTypeId: this.isAssistantServiceType
            ? Number(rpServiceTypes.Assistant)
            : Number(rpServiceTypes.Therapy),
          visitTypeId: this.visitType.id,
          includesTransportationCost: this.model.transportation,
          replacementVisitId,
          comment: this.model?.comment,
          visitAbsenceReasonId: this.visitAbsenceReason
            ? this.visitAbsenceReason.id
            : null,
          document: this.fileSelected,
          isTherapyABA: this.isTherapyABA,
          isExtendedAcademicYear: this.isExtendedAcademicYear,
          isCompensatoryRequest:
            this.compensatoryRequestSelected != null ??
            this.isCompensatoryRequest,
          compensatoryRequestId:
            this.compensatoryRequestSelected?.compensatoryRequestId ??
            this.compensatoryRequestId,
        },
        { indices: true, nullsAsUndefineds: true }
      );

      this.$emit('is-valid-model', []);
      this.$emit('on-save', {
        payload,
        validationPayload: {
          visitDate,
          visitTimeStart,
          visitTimeEnd,
          visitTimeContinuedStart,
          visitTimeContinuedEnd,
          isTherapyABA: this.isTherapyABA,
          isAbsence: this.visitType.id === visitTypes.Absence,
          isReposition: this.isRepositionVisitType,
          visitTypeId: this.visitType.id,
        },
      });
      this.cleanModel();
    },
    clearSpecialistDropdown() {
      this.specialist = null;
      if (this.$refs.specialistDropdownRef) {
        this.$refs.specialistDropdownRef.updateValue(null);
      }
    },
  },
  watch: {
    defaultSpecialistId: {
      immediate: true,
      handler(val) {
        if (val)
          this.specialist = this.getSpecialists.find((x) => x.id === val);
      },
    },
    visitAbsenceReason: {
      deep: true,
      immediate: true,
      handler(value) {
        if (!value || !value.requiresDocumentationFlag) {
          this.fileSelected = null;
        }
      },
    },
    feeScheduleCptOptions: {
      immediate: true,
      handler(value) {
        if (value) this.setFeeScheduleCpt();
      },
    },
    isCybertherapyVisitType: {
      immediate: true,
      handler(value) {
        if (value) this.model.transportation = false;
      },
    },
    visitType: {
      deep: true,
      immediate: true,
      handler() {
        this.fileSelected = null;
        this.repositionDate = null;
        this.visitAbsenceReason = null;
        this.previousAcademicYear = null;
        this.compensatoryRequestSelected = null;
        if (this.model) this.model.comment = null;
        if (
          this.visitType &&
          this.visitType.value.showPreviousYears &&
          //To avoid multiple calls, i guess it should be called once, to emulate the call on mounted process.
          this.previousAcademicYears.length == 0 &&
          this.previousCompensatories.length == 0
        ) {
          this.getPreviousAcademicYearsAndCompensatories();
        }
      },
    },
    visitDay: {
      handler(value) {
        this.model.day = value;
        this.onDayChange();
      },
    },
    showTransportation() {
      //Always reset value for avoid issues with the checkbox
      this.model.transportation = false;
    },
  },
};
</script>
<style scoped lang="scss">
@import '../../../../scss/brand_variables';

.custom-row {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.first-custom-row {
  @extend .custom-row;
  min-height: 80px;
}

.day {
  width: 5%;
}

.submit-btn-width {
  width: 4%;
}

.large-width {
  width: 38%;
}

.extra-large-width {
  width: 57%;
}

.required-transportation {
  width: 15%;
}

.custom-standard-width {
  width: 19%;
}

.file-input-width {
  width: 68px;
}

.transportation-mt {
  padding-top: 2rem !important;
}

.offset-lg {
  margin-left: 43%;
}

//

.disabled-box-content {
  margin-bottom: 5px;
}

.disabled-icon-style {
  margin-bottom: 6px;
  margin-left: 12px;
  margin-right: -6px;
}

.angle-down-style {
  font-size: 24px;
  margin-top: 8px;
  font-weight: 510 !important;
  color: $gray-500 !important;
}

.hour-size {
  width: 50px;
  margin-right: 7px;
}

.hour-size-bigger {
  width: 50px;
  margin-right: 10px;
}

.end-hour-pd-left {
  padding-left: 15px;
}

.ampm-size {
  width: 80px;
}

.select-custom-height ::v-deep .v-select,
.select-custom-height ::v-deep .v-select > div {
  height: 38px;
}

.ampm-size ::v-deep .v-select,
.ampm-size ::v-deep .v-select > div {
  height: 38px;
  width: 68px !important;
}

.hide-dropdown-arrow ::v-deep .vs__actions > svg {
  display: none;
}

.align-items-center > .custom-control {
  padding-left: 0px !important;
}

.is-disabled-input-style {
  width: 68px;
  height: 39px;
  border: 1px solid $gray-250;
  background-color: $gray-200;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#submit-btn {
  padding-left: 5px;
  padding-right: 3px;
  padding-top: 3px;
  padding-bottom: 3px;
}

.submit-btn-position {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

span > .file-input__extended ::v-deep .circle-green {
  display: none !important;
}
.first-custom-row {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  gap: 14px;
  align-items: flex-start;
  min-height: 80px;
}

.day {
  width: 55px;
  flex: 0 0 55px;
}

.custom-standard-width {
  width: auto;
  flex: 1 1 0;
  min-width: 140px;
}

.hours-column {
  min-width: 215px;
}

.cpt-width {
  flex: 0 0 170px;
  min-width: 170px;
}

.supervisor-width {
  flex: 0 0 190px;
  min-width: 190px;
}

.submit-btn-width,
.submit-btn-wrapper {
  flex: 0 0 45px;
  width: 45px;
}
.supervisor-dropdown ::v-deep .vs__selected {
  max-width: calc(100% - 35px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.supervisor-dropdown ::v-deep .vs__selected-options {
  flex-wrap: nowrap;
  min-width: 0;
}

.supervisor-dropdown ::v-deep .v-select,
.supervisor-dropdown ::v-deep .vs__dropdown-toggle {
  min-height: 38px;
  height: 38px;
}
</style>
